export const APP_LANDING_PAGE = 'ecommbxapp://landingpage';
export const APP_REGISTERED = 'ecommbxapp://registered';
